/**
 * @generated SignedSource<<c499bfe3d27d943aef23f3fc346446c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StarButtonNoteTemplate$data = {
  readonly id: string;
  readonly starred: boolean;
  readonly " $fragmentType": "StarButtonNoteTemplate";
};
export type StarButtonNoteTemplate$key = {
  readonly " $data"?: StarButtonNoteTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonNoteTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StarButtonNoteTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "starred",
      "storageKey": null
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "34187e86cffb1dea258cc296838bd9bc";

export default node;
